export default "__VITE_ASSET__CZO90FTl__"